import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  FETCH_PRODUCTS,
  FETCH_PRODUCT_DETAILS,
  FETCH_PRODUCT_REVIEWS,
  FETCH_RELATED_PRODUCTS,
  UPDATE_RECENTLY_VIEWED,
} from 'store/actionTypes';
import {
  getProductReviews,
  getProducts,
  getRelatedProducts,
  putRecentlyViewed,
} from 'services';

import {
  fetchProductsSuccess,
  fetchProductsError,
  fetchProductDetailsSuccess,
  fetchProductDetailsError,
  fetchProductReviewsSuccess,
  fetchProductReviewsError,
  fetchRelatedProductsSuccess,
  fetchRelatedProductsError,
  updateRecentlyViewedSuccess,
  updateRecentlyViewedError,
} from 'store/actions';

function* getProductItems({ payload }) {
  try {
    const response = yield call(getProducts, null, payload);
    if (!response.message) {
      yield put(
        fetchProductsSuccess(response.data, {
          ...payload,
          total: response.totalCount,
        })
      );
    } else {
      yield put(fetchProductsError(response.message));
    }
  } catch (error) {
    yield put(fetchProductsError(error));
  }
}

export function* watchFetchProducts() {
  yield takeLatest(FETCH_PRODUCTS, getProductItems);
}

function* getProductReviewItems({ payload: data }) {
  const { product, ...payload } = data;
  try {
    const response = yield call(getProductReviews, product, payload);
    if (!response.message) {
      yield put(
        fetchProductReviewsSuccess(response.data, {
          ...payload,
          total: response.totalCount,
        })
      );
    } else {
      yield put(fetchProductReviewsError(response.message));
    }
  } catch (error) {
    yield put(fetchProductReviewsError(error));
  }
}

export function* watchFetchProductReviews() {
  yield takeLatest(FETCH_PRODUCT_REVIEWS, getProductReviewItems);
}

function* getProductItem({ payload }) {
  try {
    const response = yield call(getProducts, payload.slug);
    if (!response.message) {
      yield put(fetchProductDetailsSuccess(response.data));
    } else {
      yield put(fetchProductDetailsError(response.message));
    }
  } catch (error) {
    yield put(fetchProductDetailsError(error));
  }
}

export function* watchFetchProductDetails() {
  yield takeLatest(FETCH_PRODUCT_DETAILS, getProductItem);
}

function* getRelatedProductItems({ payload }) {
  try {
    const response = yield call(getRelatedProducts, payload);
    if (!response.message) {
      yield put(fetchRelatedProductsSuccess(response.data));
    } else {
      yield put(fetchRelatedProductsError(response.message));
    }
  } catch (error) {
    yield put(fetchRelatedProductsError(error));
  }
}

export function* watchFetchRelatedProducts() {
  yield takeLatest(FETCH_RELATED_PRODUCTS, getRelatedProductItems);
}

function* updateRecentlyViewedItems({ payload }) {
  try {
    const response = yield call(putRecentlyViewed, payload);
    if (!response.message) {
      yield put(updateRecentlyViewedSuccess(response.data));
    } else {
      yield put(updateRecentlyViewedError(response.message));
    }
  } catch (error) {
    yield put(updateRecentlyViewedError(error));
  }
}

export function* watchUpdateRecentlyViewed() {
  yield takeLatest(UPDATE_RECENTLY_VIEWED, updateRecentlyViewedItems);
}

export default function* rootSaga() {
  yield all([
    fork(watchFetchProducts),
    fork(watchFetchProductReviews),
    fork(watchFetchProductDetails),
    fork(watchFetchRelatedProducts),
    fork(watchUpdateRecentlyViewed),
  ]);
}
